import {HttpHandlerFn, HttpInterceptorFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {AuthService} from "./auth.service";
import {environment} from "../../environments/environment";
import {EMPTY} from "rxjs";

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {

  const auth = inject(AuthService);

  if(req.url.startsWith('/assets'))
    return next(req);

  let clone = req.clone({
    url: environment.backEndUrl + req.url,
    withCredentials: true
  });

  if(req.url.endsWith('/login') && auth.waitTime()) {
    return EMPTY;
  }

  return next(clone);
};
